import { CREATE_ENROLLMENT, SET_ENROLLMENT, SET_LIST_ENROLLMENT, CREATE_EXTENSION_HISTORIES } from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: []
}

const enrollmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_ENROLLMENT:
      return {
        ...state,
        getList: action.payload
      }
    case CREATE_ENROLLMENT:
      return {
        ...state,
        getData: action.payload
      }
    case SET_ENROLLMENT:
      return {
        ...state,
        getData: action.payload
      }
    case CREATE_EXTENSION_HISTORIES:
      return {
        ...state,
        getData: action.payload
      }
    default:
      return state
  }
}

export default enrollmentReducer
